<template>
  <div class="mx-auto" style="padding-top: 120px">
    <div class="title-lg text-center">認証メールを送信しました。</div>
    <div class="body-md text-center mt-4">
      24時間以内にメールに記載されたURLをクリックして、<br />
      メールアドレスの変更を完了させてください。
    </div>
    <div class="body-sm text-gray-62 text-center mt-2">
      ※認証メールが届かない場合は、入力したメールアドレスが<br />
      間違っている可能性がございます。もう一度お試しください。
    </div>
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
